import AccordionContext from "./context";
import AccordionProvider from "./AccordionProvider";

export default AccordionContext;
export { AccordionProvider };
